function save(key, value) {
  if (typeof value === "string") localStorage.setItem(key, value);
  else localStorage.setItem(key, JSON.stringify(value));
}

function get(key) {
  const value = localStorage.getItem(key);
  if (value) {
    try {
      var parsed = JSON.parse(value);
      return parsed;
    } catch (error) {
      if (typeof value === "string") return value;
    }
  }

  return null;
}

function remove(key) {
  localStorage.removeItem(key);
}

function removeAll() {
  
}

export const storage = {
  save,
  get,
  remove,
  removeAll,
};
